import request from '@/utils/request'

// 查询项目信息列表
export function listProjectInfo(query) {
  return request({
    url: '/user/project-info/list',
    method: 'get',
    params: query,
  })
}

// 查询项目信息分页
export function pageProjectInfo(query) {
  return request({
    url: '/user/project-info/page',
    method: 'get',
    params: query,
  })
}

// 查询项目信息详细
export function getProjectInfo(data) {
  return request({
    url: '/user/project-info/detail',
    method: 'get',
    params: data,
  })
}

// 新增项目信息
export function addProjectInfo(data) {
  return request({
    url: '/user/project-info/add',
    method: 'post',
    data: data,
  })
}

// 修改项目信息
export function updateProjectInfo(data) {
  return request({
    url: '/user/project-info/edit',
    method: 'post',
    data: data,
  })
}

// 删除项目信息
export function delProjectInfo(data) {
  return request({
    url: '/user/project-info/delete',
    method: 'post',
    data: data,
  })
}

// 修改项目状态
export function changeProjectInfoStatus(data) {
  return request({
    url: '/user/project-info/editStatus',
    method: 'post',
    data: data,
  })
}

// 获取项目仪表盘数据
export function getProjectDashboard(params) {
  return request({
    url: '/system/dept/projectDashboard',
    method: 'get',
    params,
  })
}
